/**
 * Generated by orval 🍺
 * Do not edit manually.
 * АСИ - ИСУП
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompanyDto,
  CountryDto,
  DictionaryControllerGetDictionaryElementsParams,
  DictionaryListDto,
  DictionaryStatisticDto,
  DictionaryStatusDto,
  DictionaryWithChildrenDto,
  ExceptionModel,
  FindCountriesDto,
  NewDictionaryElementDto,
  ReferencesDto,
  UpdateDictionaryElementDto
} from '.././models'
import { baseApiInstance } from '../../../utils/api';
import type { ErrorType, BodyType } from '../../../utils/api';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Получение списка справочников
 */
export const dictionaryControllerGetDictionaryList = (
    
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<DictionaryListDto[]>(
      {url: `/v2/dictionaries`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryControllerGetDictionaryListQueryKey = () => {
    return [`/v2/dictionaries`] as const;
    }

    
export const getDictionaryControllerGetDictionaryListQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerGetDictionaryListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>> = ({ signal }) => dictionaryControllerGetDictionaryList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerGetDictionaryListQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>>
export type DictionaryControllerGetDictionaryListQueryError = ErrorType<unknown>


/**
 * @summary Получение списка справочников
 */

export function useDictionaryControllerGetDictionaryList<TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryList>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerGetDictionaryListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Список всех стран
 */
export const dictionaryControllerGetAllCountries = (
    
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<CountryDto[]>(
      {url: `/v2/dictionaries/countries`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryControllerGetAllCountriesQueryKey = () => {
    return [`/v2/dictionaries/countries`] as const;
    }

    
export const getDictionaryControllerGetAllCountriesQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>, TError = ErrorType<ExceptionModel>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerGetAllCountriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>> = ({ signal }) => dictionaryControllerGetAllCountries(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerGetAllCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>>
export type DictionaryControllerGetAllCountriesQueryError = ErrorType<ExceptionModel>


/**
 * @summary Список всех стран
 */

export function useDictionaryControllerGetAllCountries<TData = Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>, TError = ErrorType<ExceptionModel>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetAllCountries>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerGetAllCountriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Поиск по странам
 */
export const dictionaryControllerFindCountries = (
    findCountriesDto: BodyType<FindCountriesDto>,
 options?: SecondParameter<typeof baseApiInstance>,) => {
      
      
      return baseApiInstance<CountryDto[]>(
      {url: `/v2/dictionaries/countries/find`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: findCountriesDto
    },
      options);
    }
  

export const getDictionaryControllerFindCountriesQueryKey = (findCountriesDto: FindCountriesDto,) => {
    return [`/v2/dictionaries/countries/find`, findCountriesDto] as const;
    }

    
export const getDictionaryControllerFindCountriesQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerFindCountries>>, TError = ErrorType<ExceptionModel>>(findCountriesDto: FindCountriesDto, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCountries>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerFindCountriesQueryKey(findCountriesDto);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerFindCountries>>> = () => dictionaryControllerFindCountries(findCountriesDto, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCountries>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerFindCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerFindCountries>>>
export type DictionaryControllerFindCountriesQueryError = ErrorType<ExceptionModel>


/**
 * @summary Поиск по странам
 */

export function useDictionaryControllerFindCountries<TData = Awaited<ReturnType<typeof dictionaryControllerFindCountries>>, TError = ErrorType<ExceptionModel>>(
 findCountriesDto: FindCountriesDto, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCountries>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerFindCountriesQueryOptions(findCountriesDto,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Поиск по компаниям
 */
export const dictionaryControllerFindCompanies = (
    inn: string,
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<CompanyDto>(
      {url: `/v2/dictionaries/companies/${inn}`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryControllerFindCompaniesQueryKey = (inn: string,) => {
    return [`/v2/dictionaries/companies/${inn}`] as const;
    }

    
export const getDictionaryControllerFindCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>, TError = ErrorType<ExceptionModel>>(inn: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerFindCompaniesQueryKey(inn);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>> = ({ signal }) => dictionaryControllerFindCompanies(inn, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(inn), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerFindCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>>
export type DictionaryControllerFindCompaniesQueryError = ErrorType<ExceptionModel>


/**
 * @summary Поиск по компаниям
 */

export function useDictionaryControllerFindCompanies<TData = Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>, TError = ErrorType<ExceptionModel>>(
 inn: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerFindCompanies>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerFindCompaniesQueryOptions(inn,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Получение списка элементов справочника в рамках отбора
 */
export const dictionaryControllerGetDictionaryElements = (
    dictionaryId: number,
    params?: DictionaryControllerGetDictionaryElementsParams,
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<DictionaryWithChildrenDto>(
      {url: `/v2/dictionaries/${dictionaryId}/elements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDictionaryControllerGetDictionaryElementsQueryKey = (dictionaryId: number,
    params?: DictionaryControllerGetDictionaryElementsParams,) => {
    return [`/v2/dictionaries/${dictionaryId}/elements`, ...(params ? [params]: [])] as const;
    }

    
export const getDictionaryControllerGetDictionaryElementsQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>, TError = ErrorType<ExceptionModel>>(dictionaryId: number,
    params?: DictionaryControllerGetDictionaryElementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerGetDictionaryElementsQueryKey(dictionaryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>> = ({ signal }) => dictionaryControllerGetDictionaryElements(dictionaryId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dictionaryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerGetDictionaryElementsQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>>
export type DictionaryControllerGetDictionaryElementsQueryError = ErrorType<ExceptionModel>


/**
 * @summary Получение списка элементов справочника в рамках отбора
 */

export function useDictionaryControllerGetDictionaryElements<TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>, TError = ErrorType<ExceptionModel>>(
 dictionaryId: number,
    params?: DictionaryControllerGetDictionaryElementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryElements>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerGetDictionaryElementsQueryOptions(dictionaryId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Создание элемента справочника
 */
export const dictionaryControllerCreateDictionaryElement = (
    dictionaryId: number,
    newDictionaryElementDto: BodyType<NewDictionaryElementDto>,
 options?: SecondParameter<typeof baseApiInstance>,) => {
      
      
      return baseApiInstance<void>(
      {url: `/v2/dictionaries/${dictionaryId}/elements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newDictionaryElementDto
    },
      options);
    }
  


export const getDictionaryControllerCreateDictionaryElementMutationOptions = <TError = ErrorType<ExceptionModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>, TError,{dictionaryId: number;data: BodyType<NewDictionaryElementDto>}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>, TError,{dictionaryId: number;data: BodyType<NewDictionaryElementDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>, {dictionaryId: number;data: BodyType<NewDictionaryElementDto>}> = (props) => {
          const {dictionaryId,data} = props ?? {};

          return  dictionaryControllerCreateDictionaryElement(dictionaryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DictionaryControllerCreateDictionaryElementMutationResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>>
    export type DictionaryControllerCreateDictionaryElementMutationBody = BodyType<NewDictionaryElementDto>
    export type DictionaryControllerCreateDictionaryElementMutationError = ErrorType<ExceptionModel>

    /**
 * @summary Создание элемента справочника
 */
export const useDictionaryControllerCreateDictionaryElement = <TError = ErrorType<ExceptionModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>, TError,{dictionaryId: number;data: BodyType<NewDictionaryElementDto>}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof dictionaryControllerCreateDictionaryElement>>,
        TError,
        {dictionaryId: number;data: BodyType<NewDictionaryElementDto>},
        TContext
      > => {

      const mutationOptions = getDictionaryControllerCreateDictionaryElementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Получение статистики использования по элементу словаря
 */
export const dictionaryControllerGetDictionaryUsageByElement = (
    dictionaryId: number,
    elementId: number,
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<ReferencesDto[]>(
      {url: `/v2/dictionaries/usage/${dictionaryId}/elements/${elementId}`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryControllerGetDictionaryUsageByElementQueryKey = (dictionaryId: number,
    elementId: number,) => {
    return [`/v2/dictionaries/usage/${dictionaryId}/elements/${elementId}`] as const;
    }

    
export const getDictionaryControllerGetDictionaryUsageByElementQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>, TError = ErrorType<ExceptionModel>>(dictionaryId: number,
    elementId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerGetDictionaryUsageByElementQueryKey(dictionaryId,elementId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>> = ({ signal }) => dictionaryControllerGetDictionaryUsageByElement(dictionaryId,elementId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(dictionaryId && elementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerGetDictionaryUsageByElementQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>>
export type DictionaryControllerGetDictionaryUsageByElementQueryError = ErrorType<ExceptionModel>


/**
 * @summary Получение статистики использования по элементу словаря
 */

export function useDictionaryControllerGetDictionaryUsageByElement<TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>, TError = ErrorType<ExceptionModel>>(
 dictionaryId: number,
    elementId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryUsageByElement>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerGetDictionaryUsageByElementQueryOptions(dictionaryId,elementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Получение статистики по справочникам
 */
export const dictionaryControllerGetDictionaryStatistic = (
    
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<DictionaryStatisticDto>(
      {url: `/v2/dictionaries/statistic`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryControllerGetDictionaryStatisticQueryKey = () => {
    return [`/v2/dictionaries/statistic`] as const;
    }

    
export const getDictionaryControllerGetDictionaryStatisticQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryControllerGetDictionaryStatisticQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>> = ({ signal }) => dictionaryControllerGetDictionaryStatistic(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryControllerGetDictionaryStatisticQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>>
export type DictionaryControllerGetDictionaryStatisticQueryError = ErrorType<unknown>


/**
 * @summary Получение статистики по справочникам
 */

export function useDictionaryControllerGetDictionaryStatistic<TData = Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryControllerGetDictionaryStatistic>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryControllerGetDictionaryStatisticQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Редактирование элемента справочника
 */
export const dictionaryControllerUpdateDictionaryElement = (
    dictionaryId: number,
    elementId: number,
    updateDictionaryElementDto: BodyType<UpdateDictionaryElementDto>,
 options?: SecondParameter<typeof baseApiInstance>,) => {
      
      
      return baseApiInstance<void>(
      {url: `/v2/dictionaries/${dictionaryId}/elements/${elementId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDictionaryElementDto
    },
      options);
    }
  


export const getDictionaryControllerUpdateDictionaryElementMutationOptions = <TError = ErrorType<ExceptionModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>, TError,{dictionaryId: number;elementId: number;data: BodyType<UpdateDictionaryElementDto>}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>, TError,{dictionaryId: number;elementId: number;data: BodyType<UpdateDictionaryElementDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>, {dictionaryId: number;elementId: number;data: BodyType<UpdateDictionaryElementDto>}> = (props) => {
          const {dictionaryId,elementId,data} = props ?? {};

          return  dictionaryControllerUpdateDictionaryElement(dictionaryId,elementId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DictionaryControllerUpdateDictionaryElementMutationResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>>
    export type DictionaryControllerUpdateDictionaryElementMutationBody = BodyType<UpdateDictionaryElementDto>
    export type DictionaryControllerUpdateDictionaryElementMutationError = ErrorType<ExceptionModel>

    /**
 * @summary Редактирование элемента справочника
 */
export const useDictionaryControllerUpdateDictionaryElement = <TError = ErrorType<ExceptionModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>, TError,{dictionaryId: number;elementId: number;data: BodyType<UpdateDictionaryElementDto>}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof dictionaryControllerUpdateDictionaryElement>>,
        TError,
        {dictionaryId: number;elementId: number;data: BodyType<UpdateDictionaryElementDto>},
        TContext
      > => {

      const mutationOptions = getDictionaryControllerUpdateDictionaryElementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Удаление элемента справочника
 */
export const dictionaryControllerDeleteDictionaryElement = (
    dictionaryId: number,
    elementId: number,
 options?: SecondParameter<typeof baseApiInstance>,) => {
      
      
      return baseApiInstance<void>(
      {url: `/v2/dictionaries/${dictionaryId}/elements/${elementId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDictionaryControllerDeleteDictionaryElementMutationOptions = <TError = ErrorType<ExceptionModel | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>, TError,{dictionaryId: number;elementId: number}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>, TError,{dictionaryId: number;elementId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>, {dictionaryId: number;elementId: number}> = (props) => {
          const {dictionaryId,elementId} = props ?? {};

          return  dictionaryControllerDeleteDictionaryElement(dictionaryId,elementId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DictionaryControllerDeleteDictionaryElementMutationResult = NonNullable<Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>>
    
    export type DictionaryControllerDeleteDictionaryElementMutationError = ErrorType<ExceptionModel | void>

    /**
 * @summary Удаление элемента справочника
 */
export const useDictionaryControllerDeleteDictionaryElement = <TError = ErrorType<ExceptionModel | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>, TError,{dictionaryId: number;elementId: number}, TContext>, request?: SecondParameter<typeof baseApiInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof dictionaryControllerDeleteDictionaryElement>>,
        TError,
        {dictionaryId: number;elementId: number},
        TContext
      > => {

      const mutationOptions = getDictionaryControllerDeleteDictionaryElementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Получение списка статусов
 */
export const dictionaryStatusControllerGetAllStatuses = (
    
 options?: SecondParameter<typeof baseApiInstance>,signal?: AbortSignal
) => {
      
      
      return baseApiInstance<DictionaryStatusDto[]>(
      {url: `/v2/dictionary-statuses`, method: 'GET', signal
    },
      options);
    }
  

export const getDictionaryStatusControllerGetAllStatusesQueryKey = () => {
    return [`/v2/dictionary-statuses`] as const;
    }

    
export const getDictionaryStatusControllerGetAllStatusesQueryOptions = <TData = Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDictionaryStatusControllerGetAllStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>> = ({ signal }) => dictionaryStatusControllerGetAllStatuses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type DictionaryStatusControllerGetAllStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>>
export type DictionaryStatusControllerGetAllStatusesQueryError = ErrorType<unknown>


/**
 * @summary Получение списка статусов
 */

export function useDictionaryStatusControllerGetAllStatuses<TData = Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof dictionaryStatusControllerGetAllStatuses>>, TError, TData>, request?: SecondParameter<typeof baseApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDictionaryStatusControllerGetAllStatusesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



